import { Injectable } from "@angular/core";
import { AuthenticationService } from "../login/authentication/authentication.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IdentityTallerModel } from 'src/app/shared/models/login/identityTaller.model';

@Injectable({
    providedIn: "root",
})
export class TallerService {

    constructor(
        private auth: AuthenticationService,
        private http: HttpClient
    ) {}

    loginTaller(user: string, pass: string): Observable<IdentityTallerModel> {
        var url = `${this.auth.urlTaller}login/authenticate`;
        return this.http.post<IdentityTallerModel>(url, {
            login: user,
            password: pass,
        });
    }
}
